// extracted by mini-css-extract-plugin
export var createdDate = "_ii-1";
export var divider = "_ii-2";
export var headerDivider = "_ii-3";
export var messagesCard = "_ii-0";
export var messagesContainer = "_ii-6";
export var messagesContainerWrapper = "_ii-4";
export var showLeftPanelButton = "_ii-8";
export var topButtons = "_ii-7";
export var withPadding = "_ii-5";